import moment from "moment";

export function allowedDate(date) {
  var compare = moment().diff(date, "hours");
  if (compare > 0) {
    return true;
  }
  return false;
}
